import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EstablishmentDetailComponent } from './establishment-detail/establishment-detail.component';
import { RedirectEstablishmentComponent } from './redirect-establishment/redirect-establishment.component';
import { AddressesComponent } from './addresses/addresses.component';
import { LogoComponent } from './logo/logo.component';
import { CreateSpecialDisclosureComponent } from './create-special-disclosure/create-special-disclosure.component';
import { AuthGuard, FremiumGuard } from '../../guards';
import { PortalExternalRedirectComponent } from '../../components/portal-external-redirect/portal-external-redirect.component';
import { OfferComponent } from './offer/offer.component';
import { OfferListComponent } from './offer-list/offer-list.component';
// tslint:disable-next-line:max-line-length
import { InternalRegistrationEstablishmentComponent } from './internal-registration-establishment/internal-registration-establishment.component';

const children = [
  { path: 'detalhe/:establishmentId', component: RedirectEstablishmentComponent },
  { path: 'meus-dados', component: InternalRegistrationEstablishmentComponent },
  { path: 'enderecos', component: AddressesComponent },
  { path: 'logo', component: LogoComponent },
  {
    path: 'parcerias-proprias/criar-nova',
    component: PortalExternalRedirectComponent,
    data: { portalPath: '/dashboard/parcerias-exclusivas/cadastrar' },
  },
  {
    path: 'parcerias-proprias/alterar/:id',
    component: PortalExternalRedirectComponent,
    data: { portalPath: '/dashboard/parcerias-exclusivas/cadastrar', useIdQuery: true },
  },
  { path: 'internal-registration', component: InternalRegistrationEstablishmentComponent },
  { path: 'create-special-disclosure', component: CreateSpecialDisclosureComponent },
  { path: 'proposta/:offerSlug', component: OfferComponent },
  { path: 'proposta', component: OfferListComponent },
];

export const routes: Routes = [
  { path: 'business', canActivate: [AuthGuard], children },
  { path: 'negocio', canActivate: [AuthGuard], children },
  { path: 'establishment', canActivate: [AuthGuard], children },
  { path: 'estabelecimento', canActivate: [AuthGuard], children },
  { path: 'parceiro/:establishmentSlug', canActivate: [AuthGuard, FremiumGuard], component: EstablishmentDetailComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EstablishmentRoutingModule { }
